import api from './api';

const complaintService = {
  submitComplaint: async (formData) => {
    try {
      const response = await api.post('/complaints', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return { success: true, data: response.data };
    } catch (error) {
      console.error('submitComplaint error', error);
      return { success: false, error: error?.response?.data?.message || error.message };
    }
  },

  getMyComplaints: async ({ page = 1, limit = 10 } = {}) => {
    try {
      const response = await api.get('/complaints', { params: { page, limit } });
      return { success: true, data: response.data };
    } catch (error) {
      console.error('getMyComplaints error', error);
      return { success: false, error: error?.response?.data?.message || error.message };
    }
  },

  getAdminComplaints: async ({ page = 1, limit = 15, status, issueType } = {}) => {
    try {
      const response = await api.get('/admin/complaints', { params: { page, limit, status, issueType } });
      return { success: true, data: response.data };
    } catch (error) {
      console.error('getAdminComplaints error', error);
      return { success: false, error: error?.response?.data?.message || error.message };
    }
  },

  updateComplaintStatus: async (id, payload) => {
    try {
      const response = await api.patch(`/admin/complaints/${id}`, payload);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('updateComplaintStatus error', error);
      return { success: false, error: error?.response?.data?.message || error.message };
    }
  },

  addAdminReply: async (complaintId, message) => {
    try {
      const response = await api.post(`/admin/complaints/${complaintId}/replies`, { message });
      return { success: true, data: response.data };
    } catch (error) {
      console.error('addAdminReply error', error);
      return { success: false, error: error?.response?.data?.message || error.message };
    }
  },

  addUserReply: async (complaintId, message) => {
    try {
      const response = await api.post(`/complaints/${complaintId}/replies`, { message });
      return { success: true, data: response.data };
    } catch (error) {
      console.error('addUserReply error', error);
      return { success: false, error: error?.response?.data?.message || error.message };
    }
  },

  // Guest complaint methods (no auth required)
  submitGuestComplaint: async (orderNumber, guestPhone, formData) => {
    try {
      const response = await api.post('/complaints/guest', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        params: { orderNumber, guestPhone },
      });
      return { success: true, data: response.data };
    } catch (error) {
      console.error('submitGuestComplaint error', error);
      return { success: false, message: error?.response?.data?.message || error.message };
    }
  },

  getGuestComplaints: async (orderNumber, guestPhone, { page = 1, limit = 10 } = {}) => {
    try {
      const response = await api.get('/complaints/guest/track', {
        params: { orderNumber, guestPhone, page, limit },
      });
      return { success: true, data: response.data };
    } catch (error) {
      console.error('getGuestComplaints error', error);
      return { success: false, message: error?.response?.data?.message || error.message };
    }
  },

  getGuestComplaintById: async (orderNumber, guestPhone, complaintId) => {
    try {
      const response = await api.get(`/complaints/guest/${complaintId}`, {
        params: { orderNumber, guestPhone },
      });
      return { success: true, data: response.data };
    } catch (error) {
      console.error('getGuestComplaintById error', error);
      return { success: false, message: error?.response?.data?.message || error.message };
    }
  },

  addGuestReply: async (complaintId, orderNumber, guestPhone, message) => {
    try {
      const response = await api.post(`/complaints/guest/${complaintId}/replies`, { message }, {
        params: { orderNumber, guestPhone },
      });
      return { success: true, data: response.data };
    } catch (error) {
      console.error('addGuestReply error', error);
      return { success: false, error: error?.response?.data?.message || error.message };
    }
  },
};

export default complaintService;
